// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__4KExT","hoverable":"card_hoverable__b6im4"};